import type { Answers } from "./types"
import { hasMri, hasMriAddons, type QuizMarket } from "./market"

export type StepId =
  | "age"
  | "gender"
  | "hormone"
  | "omega"
  | "b_vitamins"
  | "trend"
  | "mri"
  | "mri_addons"
  | "insurance"
  | "email"

/**
 * Step list for a market. On CH this is the historical 9 steps (10 with the
 * imaging follow-ups), unchanged.
 *
 * When the user says Yes to the MRI question, a dedicated "mri_addons" step is
 * inserted right after to choose the imaging follow-ups (brain, calcium, DEXA,
 * mamma). That way the add-ons selection feels like a follow-up screen rather
 * than a long form crammed onto the MRI step.
 *
 * Steps whose products the market doesn't offer are dropped — note this is
 * "doesn't offer", not "can't book yet": a coming-soon product keeps its
 * question and routes to the waitlist (D3), which is how every other surface
 * treats `coming_soon`. Concretely, on NL the MRI question stays (full-body MRI
 * is coming-soon) but `mri_addons` disappears (all four of its products are
 * per-service `not_available`), while on DE both survive. `insurance` is CH-only.
 *
 * `market` is optional so existing callers and tests that don't care about
 * gating keep the full CH step list.
 */
export function stepsFor(answers: Answers, market?: QuizMarket): StepId[] {
  const steps: StepId[] = [
    "age",
    "gender",
    "hormone",
    "omega",
    "b_vitamins",
    "trend",
  ]

  const mriOffered = !market || hasMri(market)
  if (mriOffered) steps.push("mri")
  if (
    mriOffered &&
    answers.mri_interest === true &&
    (!market || hasMriAddons(market))
  ) {
    steps.push("mri_addons")
  }

  if (!market || market.insurance) steps.push("insurance")
  steps.push("email")
  return steps
}
